<div class="container mt-3" *ngFor="let item of groupedFees">
    <div class="row mb-3">
        <div class="col-xs-12 col-md-4">
            <img class="img-fluid service-photo" [src]="imageFee" alt="Fee image"> <!-- assets/images/no-image-fee.jpg -->
        </div>
            
        <div class="col-xs-12 col-md-8">
            <div class="row">
                <div class="col-xs-12 col-md-8">
                    <h5>{{item.displayName || item.name}}</h5>
                </div>
            </div>
            <div class="itinerary-content">
                <h6><span class="text-capitalize">{{item.description}}</span></h6>
            </div>
        </div>
    </div>
</div>
<div class="container mt-3" *ngFor="let item of groupedInsurances">
    <div class="row mb-3">
        <div class="col-xs-12 col-md-4">
            <img class="img-fluid service-photo" [src]="imageInsurance" alt="Insurance image"> <!-- assets/images/no-image-insurance.jpg -->
        </div>
            
        <div class="col-xs-12 col-md-8">
            <div class="row">
                <div class="col-xs-12 col-md-8">
                    <h5>{{item.displayName || item.name}}</h5>
                </div>
            </div>
            <div class="itinerary-content">
                <h6><span class="text-capitalize">{{item.description}}</span></h6>
            </div>
        </div>
    </div>
</div>
<ng-container *ngIf="deflusedCategories.length > 0">
    <ng-container *ngFor="let day of days || []">
        <app-optionals [day]="day" [visibleCategories]="deflusedCategories" [version]="version"
            [noImageUrl]="noImageUrl" [defaultImage]="defaultImage"
            [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes"
            [serviceIcons]="serviceIcons"></app-optionals>
    </ng-container>
</ng-container>